import { useEffect } from 'react';

import { useGrid } from '@Components/Grid';

export default function useAutoRefresh(id, status) {
  const { events: { handleAutoRefresh } } = useGrid()

  useEffect(() => {
    if (!id) {
      return;
    }

    if (!['to_process', 'processing', 'finishing'].includes(status)) {
      return;
    }

    handleAutoRefresh(id)

    const intervalId = setInterval(() => {
      handleAutoRefresh(id)
    }, status === 'to_process' ? 15000 : 5000)

    return () => clearInterval(intervalId)
  }, [handleAutoRefresh, id, status])
}
